<template>
  <v-col :cols="cols" :class="colClass" v-bind="$attrs">
    <VTextFieldWithValidation
      :disabled="disabled"
      :loading="loading"
      :rules="rules"
      outlined
      dense
      v-model.trim="dateFormatted"
      :customClass="textFieldClass"
      :label="label"
      append-icon="mdi-calendar-arrow-left"
      @blur="setParsedDate(dateFormatted)"
      @click:append="menuForDate = true"
    />

    <v-menu
      :attach="menuAttach"
      ref="menuForDate"
      v-model="menuForDate"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <v-date-picker
        :first-day-of-week="1"
        v-model="innerValue"
        :max="max"
        :min="min"
        :allowed-dates="allowedDates"
        no-title
        color="rgba(0, 0, 0, 0.87)"
        @input="menuForDate = false"
        @update:picker-date="pickerUpdate($event)"
      />
    </v-menu>
  </v-col>
</template>

<script>
import formatDate from '@/utils/formatDate';
import parseDate from '@/utils/parseDate';

export default {
  name: 'VDatePickerWithTextField',
  props: {
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    rules: {
      type: [Object, String],
      default: '',
      required: false,
    },
    textFieldClass: {
      type: String,
      default: '',
      required: false,
    },
    menuAttach: {
      type: String,
      default: '',
      required: false,
    },
    max: {
      type: String,
      default: '',
      required: false,
    },
    min: {
      type: String,
      default: '',
      required: false,
    },
    cols: {
      type: String,
      default: '4',
      required: false,
    },
    colClass: {
      type: String,
      default: '',
      required: false,
    },
    label: {
      type: String,
      default: '',
      required: false,
    },
    allowedDates: {
      type: Function,
      required: false,
    },
  },
  data: () => ({
    innerValue: '',
    menuForDate: false,
    dateFormatted: null,
  }),
  methods: {
    pickerUpdate(event) {
      this.$emit('pickerUpdate', event);
    },
    setParsedDate(dateFormatted) {
      this.innerValue = parseDate(dateFormatted);
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.dateFormatted = formatDate(newVal);
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
